import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

/**
 * Replaces a complete Bonzentrale variant region with the same region from
 * Horizon's server-rendered variant response. Horizon remains the sole owner
 * of variant selection and request cancellation.
 */
class BonzentraleVariantSync extends Component {
  #eventTarget;

  connectedCallback() {
    super.connectedCallback();
    this.#eventTarget = this.closest('.shopify-section, dialog');
    this.#eventTarget?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#eventTarget?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct, productId } = detail;
        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (productId && productId !== this.dataset.productId) {
          return;
        }

        const region = this.dataset.region;
        if (region !== 'price' && region !== 'details') return;

        const replacement = html.querySelector(`bz-variant-sync[data-region="${region}"]`);
        if (!replacement) return;

        morph(this, replacement);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[bz-variant-sync] Variant update failed:', error);
      });
  };
}

if (!customElements.get('bz-variant-sync')) {
  customElements.define('bz-variant-sync', BonzentraleVariantSync);
}
